import './instrument';
import { merge } from 'lodash';
import { createRoot } from 'react-dom/client';

merge(
  window.ReactAppEnv,
  // Local dev environment overrides can be read from .env.local
  {
    client: {
      version: import.meta.env.VITE_CLIENT_VERSION,
      build: import.meta.env.VITE_CLIENT_BUILD,
    },
    api: {
      activity: import.meta.env.DEV
        ? 'http://localhost:5050'
        : window.ReactAppEnv.api.activity,
      featureFlags: import.meta.env.DEV
        ? 'http://localhost:5053'
        : window.ReactAppEnv.api.featureFlags,
      uri: import.meta.env.VITE_API_SERVER_URI,
    },
    auth: {
      UserPoolId: import.meta.env.VITE_AUTH_USER_POOL_ID,
      ClientId: import.meta.env.VITE_AUTH_CLIENT_ID,
    },
  },
);

Promise.all([import('./app/AppPreload')]).then(
  ([{ App, createHistory, Router }]) => {
    const history = createHistory();

    createRoot(document.getElementById('root')).render(
      <Router history={history}>
        <App />
      </Router>,
    );
  },
);
